var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable */
import { useEffect, useMemo, useState, useCallback } from 'react';
import { useConfigContext } from '../context';
import { getToken } from '@/utils';
export function useQuery(url, enabled) {
    var _this = this;
    if (enabled === void 0) { enabled = true; }
    var _a = useState({
        data: null,
        loading: true,
        error: null,
    }), state = _a[0], setState = _a[1];
    var _b = useConfigContext().config, apiBaseUrl = _b.apiBaseUrl, tokenKey = _b.tokenKey, appIdentifier = _b.appIdentifier, customerSecretKey = _b.customerSecretKey;
    var authToken = getToken(tokenKey);
    var headerConfig = useMemo(function () {
        var headers = {};
        if (authToken) {
            headers.Authorization = "Bearer ".concat(authToken);
            headers.app_identifier = appIdentifier;
            headers.secret_key = customerSecretKey;
        }
        return headers;
    }, [authToken, appIdentifier, customerSecretKey]);
    var fetchData = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var res, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!enabled)
                        return [2 /*return*/];
                    setState(function (prev) { return (__assign(__assign({}, prev), { loading: true })); });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch("".concat(apiBaseUrl).concat(url), {
                            headers: headerConfig,
                        })];
                case 2:
                    res = _a.sent();
                    if (res.status === 401) {
                        // Remove token from localStorage if unauthorized
                        localStorage.removeItem(tokenKey);
                        throw new Error('Unauthorized - token removed');
                    }
                    if (!res.ok)
                        throw new Error('Failed to fetch data');
                    return [4 /*yield*/, res.json()];
                case 3:
                    data = _a.sent();
                    setState({ data: data, loading: false, error: null });
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    setState({ data: null, loading: false, error: error_1.message });
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [apiBaseUrl, url, enabled, headerConfig, tokenKey]);
    useEffect(function () {
        if (enabled) {
            fetchData();
        }
    }, [fetchData]);
    return __assign(__assign({}, state), { refetch: fetchData });
}
